import React from 'react';
import RootsImg from 'assets/roots-that-last.jpeg';

export const RootsThatLast = () => {
  return (
    <section className="w-full bg-white py-12 px-6 md:px-16 flex flex-col md:flex-row items-center justify-between">
      {/* Left Side - Text */}
      <div className="w-full md:w-1/2 text-center md:text-left mb-10 md:mb-0">
        <h2 className="text-3xl sm:text-4xl font-bold text-green-700 mb-6">GROW ROOTS THAT LAST</h2>
        <p className="text-gray-700 text-lg leading-relaxed">
          Our community goes beyond the time you spend in class. If you choose, you can plant deep
          roots into a growing global community of alumni and mentors that will continue to
          strengthen you professionally and spiritually for years to come.
        </p>
      </div>

      {/* Right Side - Image */}
      <div className="w-full md:w-1/2 flex justify-center md:justify-end">
        <img
          src={RootsImg}
          alt="Seed of Success"
          className="max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg w-full h-auto"
        />
      </div>
    </section>
  );
};
